module.exports = __webpack_public_path__ + "img/ssbg2.46f8da50.jpg";